import React from "react";
import { Button } from "react-bootstrap";

import classNames from "classnames";

import { useOpenGamesContext } from "../contexts/OpenGames";
import { useButtonHandlers } from "../hooks/useButtonHandlers";

import { currencyFormat } from "../../../lib/utils";
import { IGame } from "../../../types/api";

const GameActionButtons = ({ game }: { game: IGame }) => {
    const { umpirePay, site } = useOpenGamesContext();
    const { handleInfoClick, handleBookingClick } = useButtonHandlers();
    const now = new Date();

    const gameUmpires = umpirePay.find(
        u => u.ageLevel === game.ageLevel.ageLevel,
    )?.umpires;

    const ump1 = game.umpires?.find(
        u => u.location === "plate" && !u.pendingReplacement,
    );
    const ump2 = game.umpires?.find(
        u => u.location === "field" && !u.pendingReplacement,
    );

    const ump1PR = game.umpires?.find(
        u => u.location === "plate" && u.pendingReplacement,
    );
    const ump2PR = game.umpires?.find(
        u => u.location === "field" && u.pendingReplacement,
    );

    const ump1Pay = gameUmpires?.find(
        u => u.title === "Plate Umpire" || u.title === "Umpire",
    );
    const ump2Pay = gameUmpires?.find(u => u.title === "Field Umpire");

    return (
        <React.Fragment>
            {gameUmpires?.map(u => {
                const isPlate =
                    u.title === "Plate Umpire" || u.title === "Umpire";
                const pendingReplacement = isPlate ? ump1PR : ump2PR;
                const canCancel =
                    pendingReplacement &&
                    (isPlate
                        ? ump1?.cancelUntil &&
                          now.getTime() < new Date(ump1?.cancelUntil).getTime()
                        : ump2?.cancelUntil &&
                          now.getTime() <
                              new Date(ump2?.cancelUntil).getTime());
                return (
                    <Button
                        key={`${game.id}-${isPlate ? "plate" : "field"}`}
                        variant={
                            (isPlate && ump1 && !ump1.replacement) ||
                            (!isPlate && ump2 && !ump2.replacement)
                                ? "primary"
                                : "danger"
                        }
                        className={classNames({
                            actionButton: true,
                            available:
                                (isPlate && ump1 && !ump1.replacement) ||
                                (!isPlate && ump2 && !ump2.replacement)
                                    ? false
                                    : true,
                            pendingReplacement: pendingReplacement && canCancel,
                        })}
                        onClick={() => {
                            isPlate
                                ? ump1
                                    ? pendingReplacement && canCancel
                                        ? null
                                        : !ump1.replacement
                                          ? handleInfoClick(ump1)
                                          : handleBookingClick(game, "plate")
                                    : handleBookingClick(game, "plate")
                                : ump2
                                  ? pendingReplacement && canCancel
                                      ? null
                                      : !ump2.replacement
                                        ? handleInfoClick(ump2)
                                        : handleBookingClick(game, "field")
                                  : handleBookingClick(game, "field");
                        }}
                    >
                        {isPlate
                            ? ump1
                                ? pendingReplacement && canCancel
                                    ? "Pending Replacement"
                                    : !ump1.replacement
                                      ? ump1.name
                                      : ump1Pay &&
                                        `${currencyFormat.format(parseInt(ump1Pay.pay))} Replacement Request`
                                : ump1Pay &&
                                  `${currencyFormat.format(parseInt(ump1Pay.pay))} Book ${site === 1 ? ump1Pay.title : `Umpire 1`}`
                            : ump2
                              ? pendingReplacement && canCancel
                                  ? "Pending Replacement"
                                  : !ump2.replacement
                                    ? ump2.name
                                    : ump2Pay &&
                                      `${currencyFormat.format(parseInt(ump2Pay.pay))} Replacement Request`
                              : ump2Pay &&
                                `${currencyFormat.format(parseInt(ump2Pay.pay))} Book ${site === 1 ? ump2Pay.title : `Umpire 2`}`}
                    </Button>
                );
            })}
        </React.Fragment>
    );
};

export default GameActionButtons;
